import {
  FORGET_PASSWORD_URL,
  RESET_PASSWORD_URL,
  LOGIN_URL,
  Route,
} from '@greenkub-fronts/shared/router';

import ForgetPasswordForm from '../ui/web/forget-password-form/forget-password';
import LoginForm from '../ui/web/login-form/login-form';
import ResetPasswordForm from '../ui/web/reset-password-form/reset-password-form';

export const ROUTER_LOGIN: Route[] = [
  {
    path: FORGET_PASSWORD_URL,
    component: <ForgetPasswordForm />,
  },
  {
    path: RESET_PASSWORD_URL,
    component: <ResetPasswordForm />,
  },
  {
    path: LOGIN_URL,
    component: <LoginForm />,
  },
];
